module.exports = __webpack_public_path__ + "img/germany-neoplasm-male.13665c83.png";